export default __webpack_public_path__ + "static/media/IMG1.589fc6dd.jpg";